import { TranslateField } from "../../types/translate-field";

export interface GetCatgoryResponse {
    items: CategoryInfo[]
}

export interface CategoryInfo {
    category_id: string
    category_eng: string
    category_cnt: string
    category_cns: string
    display_order: string
}

export function TranslateCategory(cat: CategoryInfo): TranslateField {
    return {
        key: cat.category_id,
        values: [
            { locale: 'en', value: cat.category_eng},
            { locale: 'zh', value: cat.category_cnt},
            { locale: 'cn', value: cat.category_cns},
        ],
        
    }
}